export const DEFAULT_ORDER = 'auto';
export const DEFAULT_SORT = 'popularity';
export const DEFAULT_VENDOR = 'cardkingdom';
export const DEFAULT_ORDERING = '-popularity,identity_count,card_count,-created';
